import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface WordmarkProps {
    compact?: boolean
    className?: string
}

// Typographic logo: the blue and yellow "A" mark followed by "Ativa Comex". In compact mode "Comex" folds away.
export const Wordmark: FC<WordmarkProps> = ({ compact = false, className }): ReactNode => {
    const foldClass = cn(
        'inline-block overflow-hidden whitespace-nowrap transition-[max-width,opacity] duration-500 ease-out',
        compact ? 'max-w-0 opacity-0' : 'max-w-[7em] opacity-100'
    )

    return (
        <span
            aria-hidden='true'
            className={cn('flex items-center font-heading text-[15px] uppercase leading-none tracking-[-0.01em] md:text-[17px]', className)}
        >
            <svg viewBox='0 0 40 40' className='mr-[0.45em] size-[1.35em] shrink-0'>
                <path d='M4 37 L15 4 H23 L12 37 Z' className='fill-brand-soft' />
                <path d='M23 4 L36 37 H28 L22 20 Z' className='fill-highlight' />
                <path d='M10 28 H31 L28.5 33.5 H8 Z' className='fill-highlight' />
            </svg>
            <span>Ativa</span>
            <span className={cn('inline-block transition-[width] duration-500', compact ? 'w-0' : 'w-[0.45em]')} />
            <span className={foldClass}>Comex</span>
        </span>
    )
}
